export const width_bwcallergy = {
    width_i: 30,
}

export const symbol_status_bwcallergy_eng = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 288,
        Ypos_img: 307,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus acidophilus`,
        Xpos_img: 288,
        Ypos_img: 404,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 288,
        Ypos_img: 498,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium lactis`,
        Xpos_img: 288,
        Ypos_img: 594,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus reuteri`,
        Xpos_img: 288,
        Ypos_img: 715,
        page: 8,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    }
]

export const symbol_status_bwcallergy_thai = [
    {
        title: `Bifidobacterium bifidum`,
        Xpos_img: 288,
        Ypos_img: 248,
        page: 7,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus acidophilus`,
        Xpos_img: 288,
        Ypos_img: 346,
        page: 7,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus rhamnosus`,
        Xpos_img: 288,
        Ypos_img: 440,
        page: 7,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Bifidobacterium lactis`,
        Xpos_img: 288,
        Ypos_img: 535,
        page: 7,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    },
    {
        title: `Lactobacillus reuteri`,
        Xpos_img: 288,
        Ypos_img: 655,
        page: 7,
        status_mapping: [
            { result:'Deficient', img: 'wrong_new' },
            { result:'Slightly Deficient', img: 'wrong_new' },
            { result:'Normal', img: 'correct_new' },
        ]
    }
]